export const NotificationType = {
  Bidding: 1,
  Vehicle: 2,
  Favorite: 3,
  Message: 4,
}
